import { css } from 'lit';

export const effectStyles = css`
  :host([effect='wave']) > div {
    background: linear-gradient(
      to right,
      var(--vn-skeleton-foreground-color),
      var(--vn-skeleton-foreground-color) 50%,
      var(--vn-skeleton-background-color) 50%,
      var(--vn-skeleton-background-color) 100%
    );
    background-size: 200% 200%;
    animation: skeleton-wave-loading 3s ease-in-out infinite normal;
  }

  @keyframes skeleton-wave-loading {
    0% {
      background-position: 0%;
    }
    100% {
      background-position: -200%;
    }
  }

  :host([effect='pulse']) > div {
    background-size: 300%;
    animation: skeleton-pulse-loading 1s linear infinite alternate;
  }
    
  @keyframes skeleton-pulse-loading {
    0% {
      background: var(--vn-skeleton-background-color);
    }
    100% {
      background: var(--vn-skeleton-foreground-color);
    }
  }
  :host([effect='none']) > div {
    background: var(--vn-skeleton-foreground-color);
  }
`;
